/* eslint-disable consistent-return */
/* eslint-disable function-paren-newline */
import axios from 'axios';
import {
  logout as removeUserDetailsAndLogoutUser,
  STORAGE_TWO_FACTOR_REQUIRED,
} from './auth';
import { baseURL, headers, storeUserDetailsToLocalStorage } from './apiHelper';

export const FREELANCER_2FA_REQUIRED_ERROR_CODE = 'freelancer_2fa_required';
// 2FA required by an admin, returned by endpoints that are not for freelancer work
export const TWO_FACTOR_REQUIRED_ERROR_CODE = '2fa_required';

// Const(s)
const apiClient = axios.create({
  withCredentials: true,
  baseURL,
  headers,
});

// Let(s)
let isRefreshingAccessToken = false;
let requestsToRefresh = [];

// Method(s)
apiClient.interceptors.request.use((config) => {
  isRefreshingAccessToken = false;
  requestsToRefresh = [];

  const newConfig = config;

  return newConfig;
});

function refreshAccessToken() {
  return axios.post(
    `${baseURL}refresh-token`,
    {},
    {
      headers: {
        ...headers,
      },
      withCredentials: true,
    },
  );
}

apiClient.interceptors.response.use(null, (error) => {
  try {
    const { response, config } = error;

    // Unauthorized user
    if (response.status === 401) {
      // Check if we are in the middle of refreshing the token
      if (!isRefreshingAccessToken) {
        isRefreshingAccessToken = true;

        refreshAccessToken()
          .then((resRefreshToken) => {
            storeUserDetailsToLocalStorage(resRefreshToken.data);

            requestsToRefresh.forEach((cb) =>
              cb(resRefreshToken.data.accessToken),
            );
          })
          .catch(() => {
            removeUserDetailsAndLogoutUser();
            requestsToRefresh.forEach((cb) => cb(null));
          });
      }
      return new Promise((resolve, reject) => {
        requestsToRefresh.push((token) => {
          if (token) {
            resolve(axios(config));
          } else {
            reject(error);
          }
        });
      });
    }

    // Session without 2FA once 2FA is required: log in again to enrol / enter a code
    if (
      response.status === 403 &&
      [
        FREELANCER_2FA_REQUIRED_ERROR_CODE,
        TWO_FACTOR_REQUIRED_ERROR_CODE,
      ].includes(response.data?.errorCode)
    ) {
      sessionStorage.setItem(STORAGE_TWO_FACTOR_REQUIRED, 'true');
      removeUserDetailsAndLogoutUser();
    }

    return Promise.reject(error);
  } catch (e) {
    removeUserDetailsAndLogoutUser();
  }
});

export default apiClient;
